module.exports = __webpack_public_path__ + "static/media/main idea.c96f783b.mp3";